<template>
  <div class="verify">
    <div class="font-h1 title">
      我的审批
    </div>
    <tab :tab-list="verifyTabList" :default-active="currentState" @click="tabClick">
      <template v-slot="props">
        {{ props.tab.label }}
      </template>
    </tab>
    <base-table
      v-loading="dataLoading"
      :data="verifyRecords"
      @row-click="recordClick"
      show-line-height-box
      :page-info="pageInfo"
      @page-change="refreshTable"
    >
      <el-table-column
        v-for="(col, index) in tableColumns"
        :key="col.value"
        :prop="col.value"
        :label="col.label"
        show-overflow-tooltip
        width="140"
        :fixed="index === 0"
        :label-class-name="col.value == 'dataTitle' ? 'data-col-label' : ''"
        :class-name="col.value == 'dataTitle' ? 'data-col' : ''"
      >
        <template slot-scope="scope">
          <template v-if="col.value == 'dataTitle'">
            <template v-if="!scope.row.deleted">
              <span @click.stop="openSheetDetail(scope.row)">
                {{ _.get(scope.row, col.value) }}
              </span>
            </template>
            <span v-else style="text-decoration: line-through;">数据已删除</span>
          </template>
          <template v-else-if="['user.name', 'verifyUser.name'].includes(col.value)">
            <template v-if="!scope.row.deleted">
              {{ _.get(scope.row, col.value) }}
            </template>
            <span v-else style="text-decoration: line-through;">数据已删除</span>
          </template>
          <template v-else-if="col.value === 'stateZh'">
            <div
              v-if="_.get(scope.row, col.value) === '待审核'"
              class="option-item option-bg-orange"
            >
              待审核
            </div>
            <div
              v-else-if="_.get(scope.row, col.value) === '已审核'"
              class="option-item option-bg-green"
            >
              已审核
            </div>
            <div
              v-else-if="_.get(scope.row, col.value) === '已撤回'"
              class="option-item option-bg-gray"
            >
              已撤回
            </div>
          </template>
          <template v-else-if="col.value === 'passZh'">
            <div v-if="_.get(scope.row, col.value) === '驳回'" class="option-item option-bg-red">
              驳回
            </div>
            <div
              v-else-if="_.get(scope.row, col.value) === '通过'"
              class="option-item option-bg-green"
            >
              通过
            </div>
            <div
              v-else-if="_.get(scope.row, col.value) === '撤回'"
              class="option-item option-bg-gray"
            >
              撤回
            </div>
          </template>
          <template v-else>
            {{ _.get(scope.row, col.value) }}
          </template>
        </template>
      </el-table-column>
    </base-table>
    <task-detail-dialog
      ref="detailDialog"
      :task-id="taskId"
      :visible.sync="taskDetailVisible"
      @data-changed="refreshTable"
    ></task-detail-dialog>
    <sheet-detail-dialog
      ref="detailDialog"
      :visible.sync="sheetDetailVisible"
      :data-id="sheetDataId"
      :app-id="sheetAppId"
      @data-changed="refreshTable"
    ></sheet-detail-dialog>
    <verify-sheet-data-dialog
      ref="verifySheetDataDialog"
      from="todo"
      :verify-ids="verifyIds"
      @task-verified="refreshTable"
      @turnVerify="turnVerify"
    ></verify-sheet-data-dialog>
  </div>
</template>

<script>
import Tab from "@/components/UIComponents/Tab"
import { verifyTabList, tableColumns } from "@/views/Company/Todo/static"
import BaseTable from "@/components/UIComponents/BaseTable"
import * as TaskApi from "@/api/task"
import TaskDetailDialog from "@/components/Task/DetailDialog"
import SheetDetailDialog from "@/components/Sheet/DetailDialog"
import VerifySheetDataDialog from "@/components/VerifySheetDataDialog"

export default {
  name: "Verify",
  components: { VerifySheetDataDialog, Tab, BaseTable, TaskDetailDialog, SheetDetailDialog },
  props: {
    appId: String
  },
  data() {
    return {
      tableColumns,
      verifyTabList,
      verifyRecords: [],
      currentState: "PENDING",
      dataLoading: false,
      taskDetailVisible: false,
      sheetDetailVisible: false,
      taskId: "",
      sheetDataId: "",
      sheetAppId: "",
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters.userInfo
    },
    reqListBody() {
      let result = {
        state: this.currentState,
        page: this.pageInfo.currentPage - 1,
        size: this.pageInfo.pageSize
      }
      if (this.appId !== undefined) {
        result.appIds = [this.appId]
        result.projectIds = []
      }
      return result
    },
    verifyIds() {
      return this.verifyRecords
        .filter(verifyRecord => verifyRecord.dataTitle !== "数据已删除")
        .map(verifyRecord => verifyRecord.id)
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.refreshTable()
    },
    refreshTable() {
      this.dataLoading = true
      TaskApi.getTasks(this.reqListBody)
        .then(pageable => {
          this.pageInfo.total = pageable.totalElements
          this.verifyRecords = pageable.content.map(row => {
            if (row.status == "RECALLED") {
              row.passZh = "撤回"
              row.stateZh = "已撤回"
            } else if (row.pass === undefined) {
              row.stateZh = "待审核"
            } else {
              row.stateZh = "已审核"
              if (row.pass === true) {
                row.passZh = "通过"
              } else if (row.pass === false) {
                row.passZh = "驳回"
              }
            }
            if (row.taskId) {
              row.dataTitle = row.taskName
              row.dataPath = row.projectName
            } else {
              if (!row.appName || !row.sheetName) row.dataPath = ""
              else row.dataPath = row.appName + " / " + row.sheetName
            }
            if (row.dataTitle === "数据已删除") {
              row.deleted = true
            }
            return row
          })
        })
        .finally(() => (this.dataLoading = false))
    },
    tabClick(value) {
      this.currentState = value
      this.pageInfo.currentPage = 1
      this.refreshTable()
    },
    recordClick(record) {
      // 审批的 数据/任务 已经不存在了，询问是否删除该审批
      if (record.dataTitle === "数据已删除") {
        this.$confirm("审批数据不存在，是否删除该记录？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            TaskApi.deleteVerifyRecord(record.id)
              .then(() => this.$message.success("处理成功"))
              .finally(this.refresh)
          })
          .catch(() => {
            //
          })
        return
      }
      this.$refs.verifySheetDataDialog.open(record, record.taskId ? "task" : "sheet")
    },
    reject(record) {
      this.$prompt("请输入驳回原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(({ value }) => {
        TaskApi.verifyTask(record.userTaskId, 0, value)
          .then(() => this.$message.success("处理成功"))
          .finally(this.refresh)
      })
    },
    openSheetDetail(row) {
      if (row.taskId) {
        this.taskId = row.taskId
        this.taskDetailVisible = true
      } else {
        this.sheetDataId = row.dataId
        this.sheetAppId = row.appId
        this.sheetDetailVisible = true
      }
    },
    turnVerify(verifyId) {
      let record = this.verifyRecords.find(verifyRecord => verifyRecord.id === verifyId)
      this.$refs.verifySheetDataDialog.open(record, record.taskId ? "task" : "sheet", true)
    }
  }
}
</script>

<style lang="scss" scoped>
.verify {
  height: 100%;
  display: flex;
  flex-flow: column;
  .title {
    padding: 18px;
  }
  .tab {
    padding-left: 15px;
  }
  .base-table {
    flex: auto;
    overflow: hidden;
    .option-item {
      line-height: 22px;
      display: inline-block;
      padding: 0 6px;
      border-radius: 6px;
      color: white;
      margin-right: 5px;
      white-space: nowrap;
    }
    ::v-deep {
      .data-col-label {
        color: $color-font-first;
      }
      .data-col {
        color: $color-main;
      }
    }
  }
}
</style>
